import React from 'react'
import ForbiddenErrorContainer from 'src/containers/Error/403'

const ForbiddenErrorPage: React.FC = () => {
  return <ForbiddenErrorContainer />
}

export const PATH = '/403' as const
export default ForbiddenErrorPage
